import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

const ParagraphTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text, align } = props

	return (
		<Typography variant="body2" align={align}>
			{text}
		</Typography>
	)
}

export default ParagraphTypographyAtom
